import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Loader2, BellOff, CheckCircle2, AlertTriangle, MinusCircle } from "lucide-react";

const TYPE_LABEL = {
  nova_solicitacao: "Confirmação ao cliente",
  nova_solicitacao_admin: "Aviso ao administrador",
  atualizacao_status: "Alteração de status",
  orcamento_enviado: "Orçamento enviado",
};

const DELIVERY = {
  "E-mail enviado": { icon: CheckCircle2, cls: "text-emerald-400" },
  "Falha no envio": { icon: AlertTriangle, cls: "text-amber-400" },
  "Não configurado": { icon: MinusCircle, cls: "text-slate-500" },
};

const fdt = (iso) =>
  iso ? new Date(iso).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" }) : "—";

export default function Notificacoes() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/notifications");
        setItems(data);
      } catch {
        setItems([]);
      }
    })();
  }, []);

  return (
    <div data-testid="notifications-page">
      <h1 className="display text-3xl font-extrabold uppercase">Histórico de Notificações</h1>
      <p className="mt-1 text-sm text-slate-500">
        Registro de todos os e-mails disparados pelo sistema. Falhas são registradas sem afetar o orçamento.
      </p>

      <div className="mt-6 card-tactical rounded-md overflow-hidden">
        {!items ? (
          <div className="py-16 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-slate-600" /></div>
        ) : !items.length ? (
          <div className="py-16 text-center" data-testid="notifications-empty">
            <BellOff className="w-10 h-10 text-slate-700 mx-auto" strokeWidth={1.25} />
            <p className="mt-3 text-sm text-slate-500">Nenhuma notificação registrada ainda.</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm" data-testid="notifications-table">
              <thead>
                <tr className="text-left text-xs uppercase tracking-wider text-slate-500 border-b border-slate-800">
                  <th className="px-5 py-3.5 font-medium">Data/Hora</th>
                  <th className="px-5 py-3.5 font-medium">Destinatário</th>
                  <th className="px-5 py-3.5 font-medium">Tipo</th>
                  <th className="px-5 py-3.5 font-medium">Protocolo</th>
                  <th className="px-5 py-3.5 font-medium">Status</th>
                  <th className="px-5 py-3.5 font-medium">Situação</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-800/70">
                {items.map((n) => {
                  const d = DELIVERY[n.delivery] || DELIVERY["Falha no envio"];
                  return (
                    <tr key={n.id} className="hover:bg-slate-900/50 transition-colors" data-testid={`notification-row-${n.id}`}>
                      <td className="px-5 py-3.5 mono text-slate-400 whitespace-nowrap">{fdt(n.created_at)}</td>
                      <td className="px-5 py-3.5 text-slate-300 max-w-[220px] truncate" title={n.recipient}>{n.recipient}</td>
                      <td className="px-5 py-3.5 text-slate-400">{TYPE_LABEL[n.type] || n.type}</td>
                      <td className="px-5 py-3.5 mono text-slate-300">{n.quote_number}</td>
                      <td className="px-5 py-3.5 text-slate-400 text-xs">
                        {n.prev_status ? `${n.prev_status} → ${n.new_status}` : n.new_status || "—"}
                      </td>
                      <td className="px-5 py-3.5">
                        <span className={`inline-flex items-center gap-1.5 text-xs ${d.cls}`} title={n.error || ""}>
                          <d.icon className="w-4 h-4" /> {n.delivery}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
